import React, { useState, useEffect, useRef  } from 'react'
import './new.scss'
import Sidebar from '../../../components/sidebar/Sidebar'
import Navbar from '../../../components/navbar/Navbar'
import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';
import {serverTimestamp, setDoc, doc, collection, query, where, writeBatch, onSnapshot, addDoc } from "firebase/firestore";
import { auth, db, storage, messaging } from "../../../firebase";
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import { useNavigate } from "react-router-dom"
import { TextField, Button } from '@mui/material';
import Divider from '@mui/material/Divider';

import Box from '@mui/material/Box';

// import { Editor } from "@tinymce/tinymce-react";


const New = () => {

    

  const [inputFields, setInputFields] = useState([
    { link: '', message: '' }
  ]);

  const [isloading, setIsloading ] = useState(false)

  const today = new Date().toDateString()

  const navigate = useNavigate();



  // const editorRef = useRef(null);


  // const logContent = () => {

  //   if (editorRef.current) {

  //     console.log(editorRef.current.getContent());

  //   }
    
  // };




    const handleReleases = async(e) => {
  
      e.preventDefault()

      setIsloading(true)
  
      try{
  
         await addDoc(collection(db, "releases"), {
         
            futureRelease : inputFields,
            status : 'inactive',
            date : today,
            timeStamp : serverTimestamp(),
   
          
        }
  
        );

        setIsloading(false)
  
        navigate('/releases')
        console.log()
        
      }catch (err) {
        console.log(err);
      } finally{

        setIsloading(false)

      }
  
    }


  const handleInputChange = (index, event) => {
    const values = [...inputFields];
    values[index][event.target.name] = event.target.value;
    setInputFields(values);
  };

  const handleAddFields = () => {
    setInputFields([...inputFields, { link: '', message: ''}]);
  };

  const handleRemoveFields = (index) => {
    const values = [...inputFields];
    values.splice(index, 1);
    setInputFields(values);
  };



  return (
    <div className="new">
      {/* {isloading && <Spinner />} */}
      <Sidebar/>
      <div className="newContainer">
      <Navbar/>
        <div className='top'>
          <div className='topLeft'><h1>New Future Release</h1></div>
          
          <div className='topRight'>
          <Breadcrumbs aria-label="breadcrumb">
            <Link underline="hover" color="inherit" href="/">
              Home
            </Link>
            <Link
              underline="hover"
              color="inherit"
              href="/releases"
            >
              Releases List
            </Link>
            <Typography color="green">New Release</Typography>
          </Breadcrumbs>
          </div>
        </div>
        <div className='bottom'>
       
        <div className='right'>
          <div className='form'>



                  {inputFields.map((fieldGroup, index) => (
                    <div key={index} style={{display: 'flex', flexDirection:'column', width: '100%', gap:30}}>

                    
                      <TextField
                        type="text"
                        name="link"
                        placeholder="Enter Link"
                        value={fieldGroup.link}
                        onChange={(event) => handleInputChange(index, event)}
                        style={{width:'100%'}}
                      />
                      <TextField
                        type="text"
                        name="message"
                        placeholder="Enter Message"
                        value={fieldGroup.message}
                        multiline
                        minRows={3}
                        maxRows={10}
                        onChange={(event) => handleInputChange(index, event)}
                        style={{width:'100%'}}
                      />

                      {/* <Editor
                          apiKey="z3rvv24eure5gnxloggn7mv470ku23i45xsw6vcq4iziglkp"
                          onInit={(evt, editor) => (editorRef.current = editor)}
                          initialValue="<p>Start creating something amazing...</p>"
                          init={{
                            height: 500,
                            menubar: true,
                            plugins: [
                              "advlist autolink lists link image charmap print preview anchor",
                              "searchreplace visualblocks code fullscreen",
                              "insertdatetime media table paste code help wordcount",
                            ],
                            toolbar:
                              "undo redo | formatselect | bold italic backcolor | \
                              alignleft aligncenter alignright alignjustify | \
                              bullist numlist outdent indent | removeformat | help",
                          }}
                      /> */}
                        {/* <button onClick={logContent}>Log Content</button> */}
                    
                
                      {inputFields.length > 1 && ( // Optional: disable remove button if only one field group
                        <Button onClick={() => handleRemoveFields(index)}  style={{width:'10%', }}> Remove</Button>
                      )}
                    </div>
                  ))}

            
                <div style={{display: 'flex', flexDirection:'column', gap:10, width:'100%', marginBottom:0, marginRight:0}}>
                  
                   <Button onClick={handleAddFields} style={{backgroundColor:'darkblue', alignSelf:'flex-end'}}>
                    + Add New Future Release</Button>

                </div>


                <hr style={{width:'100%', height:2, color:'$eee'}}/>

                  <Button onClick={handleReleases} style={{width:'100%',height:60,  backgroundColor:'rgb(15, 31, 175)'}}>{isloading ? '...loading' : 'Save Releases'}</Button>


          </div>
        </div>
        </div>
      </div>
    </div>
  )
}

export default New
